import { render, staticRenderFns } from "./wechatWork__list.vue?vue&type=template&id=80b15a3e"
import script from "./wechatWork__list.vue?vue&type=script&lang=js"
export * from "./wechatWork__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports